"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const TermsAgreement_1 = __importDefault(require("./TermsAgreement"));
const TermsAgreementShell = ({ getLenderTerms, lenderName, locationId, }) => {
    const [terms, setTerms] = (0, react_1.useState)(null);
    const initData = async () => {
        const resp = await getLenderTerms(locationId, lenderName);
        if (resp && resp.terms) {
            setTerms(resp.terms);
        }
    };
    (0, react_1.useEffect)(() => {
        initData();
    }, []);
    return (0, jsx_runtime_1.jsx)(TermsAgreement_1.default, { terms: terms });
};
const mapDispatchToProps = {
    getLenderTerms: apiActions.getLenderTerms,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(null, mapDispatchToProps))(TermsAgreementShell);
